// Rewritten full script for xMainProductSubscription
// - Robust click handling using composedPath() (handles SVG and shadow DOM)
// - Keyboard support (Enter / Space)
// - Injects a small CSS fix for SVG pointer cursor
// Drop this in your theme JS (replace existing main-product-subscription.js content)

if (!window.Eurus) window.Eurus = {};
if (!window.Eurus.loadedScript) window.Eurus.loadedScript = new Set();

if (!window.Eurus.loadedScript.has('main-product-subscription.js')) {
  window.Eurus.loadedScript.add('main-product-subscription.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {

      Alpine.data('xMainProductSubscription', (
        sectionId,
        price,       // kept for compatibility but NOT used for one-time price
        variantId,
        productTitle,
        shopCurrency
      ) => ({

        container: null,
        mainProductPrice: null,
        variantPriceFromScript: null,
        currentVariantIdFromScript: null,
        main_product: { main_product: { selling_plan: false, variants: {} } },
        haveSubscription: false,
        activeSellingPlan: false,
        activeSellingname: false,
        _delegatedHandlersAttached: false,
        _qtyMutationObserver: null,
        _externalVariantHandler: null,

        initSubscription(el) {
          this.container = el;
          this._parseMainProductData();

          try {
            const selVariantScript = (this.container && this.container.querySelector('script[type="application/json"][data-selected-variant]'))
              || document.querySelector('script[type="application/json"][data-selected-variant]');

            if (selVariantScript) {
              const selVariantJson = JSON.parse(selVariantScript.textContent || selVariantScript.innerText);
              this.currentVariantIdFromScript = selVariantJson?.id ?? null;
              const svPriceRaw = window.variantPriceOverrides?.[String(selVariantJson?.id)] ?? selVariantJson?.price ?? selVariantJson?.presentment_price ?? null;
              if (svPriceRaw != null) {
                this.variantPriceFromScript = Number(svPriceRaw);
                this.mainProductPrice = Number(svPriceRaw);
              }
            }
          } catch (err) {
            console.error('[xMainProductSubscription] error reading data-selected-variant script', err);
          }

          if (this.mainProductPrice === null) {
            this.mainProductPrice = 0;
          }
          this.renderPrice();
           
          this._attachDelegatedLoopHandlers();
          this._wireExternalVariantListeners();
          const sel = document.querySelector('select[name="id"]') || document.querySelector('input[name="id"]:checked');
          const initialVariantId = sel ? sel.value : (variantId || null);
          if (initialVariantId) {
            if (window.updateMainProductData) {
              try { window.updateMainProductData({ id: initialVariantId }); } catch(e){}
            } else {
              document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: { id: initialVariantId } } }));
            }
          }

          this.haveSubscription = !!(this.main_product?.main_product?.selling_plan);
          if (this.haveSubscription) {
            this._startLoopWatcher(el);
          }
        },

        _parseMainProductData() {
          const jsonEl = (this.container && this.container.querySelector('#main-product-data')) || document.querySelector('#main-product-data');
          if (!jsonEl) {
            this.main_product = { main_product: { selling_plan: false, variants: {} } };
            this.haveSubscription = false;
            return;
          }
          try {
            let raw = jsonEl.innerHTML.replace(/<!--[\s\S]*?-->/g, '').replace(/,(\s*[}\]])/g, '$1');
            this.main_product = JSON.parse(raw);
            if (!this.main_product?.main_product?.variants) this.main_product.main_product.variants = this.main_product.main_product.variants || {};
            this.haveSubscription = !!(this.main_product?.main_product?.selling_plan);
          } catch (e) {
            console.error('[xMainProductSubscription] _parseMainProductData error', e);
            this.main_product = { main_product: { selling_plan: false, variants: {} } };
            this.haveSubscription = false;
          }
      
        },

        _exposeUpdateHelper() {
          if (window.updateMainProductData) return;
          window.updateMainProductData = (variantOrJson) => {
            try {
              if (!variantOrJson) return;
              if (variantOrJson.main_product) {
                this.main_product = variantOrJson;
                const domEl = document.getElementById('main-product-data');
                if (domEl) domEl.textContent = JSON.stringify(this.main_product);
              } else if (variantOrJson.id) {
                const entry = this.main_product?.main_product?.variants?.[String(variantOrJson.id)];
                if (entry) {
                  this.main_product.main_product.selling_plan = entry.selling_plan || false;
                } else {
                  if (Array.isArray(variantOrJson.selling_plan_allocations) && variantOrJson.selling_plan_allocations.length) {
                    const plans = {};
                    variantOrJson.selling_plan_allocations.forEach(spa => {
                      const name = (spa.selling_plan && spa.selling_plan.name) ? spa.selling_plan.name.trim() : (spa.name || `plan_${spa.id}`);
                      const id = (spa.selling_plan && spa.selling_plan.id) ? spa.selling_plan.id : (spa.id || null);
                      const price = spa.price !== undefined ? spa.price : (spa.presentment_price ?? null);
                      plans[name] = { id: id, price: price };
                    });
                    this.main_product.main_product.selling_plan = plans;
                  } else {
                    this.main_product.main_product.selling_plan = false;
                  }
                }

                const vPrice = window.variantPriceOverrides?.[String(variantOrJson.id)] ?? variantOrJson.price ?? variantOrJson.presentment_price ?? null;
                if (vPrice != null) {
                  this.variantPriceFromScript = Number(vPrice);
                  if (!this.activeSellingPlan) {
                    this.mainProductPrice = this.variantPriceFromScript;
                    this.renderPrice();
            
                  }
                }
                const domEl = document.getElementById('main-product-data');
                if (domEl) domEl.textContent = JSON.stringify(this.main_product);
              }
              setTimeout(() => this._applySellingPlanAfterExternalChange(), 0);
            } catch (e) {
              console.error('[xMainProductSubscription] updateMainProductData error', e);
            }
          };
        },

        _wireExternalVariantListeners() {
          this._exposeUpdateHelper();

          this._externalVariantHandler = (e) => {
            try {
              const variant = e?.detail?.variant || e?.detail;
              if (!variant) return;

              if (!this.main_product?.main_product?.variants || Object.keys(this.main_product.main_product.variants).length === 0) {
                this._parseMainProductData();
              }

              const mapEntry = this.main_product?.main_product?.variants?.[String(variant.id)];
              if (mapEntry) {
                this.main_product.main_product.selling_plan = mapEntry.selling_plan || false;
              } else {
                if (Array.isArray(variant.selling_plan_allocations) && variant.selling_plan_allocations.length) {
                  const plans = {};
                  variant.selling_plan_allocations.forEach(spa => {
                    const name = (spa.selling_plan && spa.selling_plan.name) ? spa.selling_plan.name.trim() : (spa.name || `plan_${spa.id}`);
                    const id = (spa.selling_plan && spa.selling_plan.id) ? spa.selling_plan.id : (spa.id || null);
                    const price = spa.price !== undefined ? spa.price : (spa.presentment_price ?? null);
                    plans[name] = { id: id, price: price };
                  });
                  this.main_product.main_product.selling_plan = plans;
                } else {
                  this.main_product.main_product.selling_plan = false;
                }
              }

              this.haveSubscription = !!(this.main_product?.main_product?.selling_plan);

              const vPrice = window.variantPriceOverrides?.[String(variant.id)] ?? variant.price ?? variant.presentment_price ?? null;
              if (vPrice != null) {
                this.variantPriceFromScript = Number(vPrice);
                if (!this.activeSellingPlan) {
                  this.mainProductPrice = this.variantPriceFromScript;
                  this.renderPrice();
               
                }
              }

              const domEl = document.getElementById('main-product-data');
              if (domEl) domEl.textContent = JSON.stringify(this.main_product);

              setTimeout(() => {
                this._applySellingPlanAfterExternalChange();
                const subGroup = this.container.querySelector('[data-loop-widget-selling-plan-group]');
                if (subGroup) this._handleApplySubscriptionFromGroup(subGroup);
              }, 20);

            } catch (err) {
              console.error('[xMainProductSubscription] _externalVariantHandler error', err);
            }
          };

          document.addEventListener('variant:change', this._externalVariantHandler);
          document.addEventListener('variantChange', this._externalVariantHandler);
          document.addEventListener('eurus:variant:changed', this._externalVariantHandler);
        },

        // ---------- Improved delegated handlers ----------
        _attachDelegatedLoopHandlers() {
          if (!this.container || this._delegatedHandlersAttached) return;
          this._delegatedHandlersAttached = true;

          // Ensure minimal pointer cursor CSS for SVG radios (injected once)
          try {
            if (!document.getElementById('xmainproduct-sub-css')) {
              const s = document.createElement('style');
              s.id = 'xmainproduct-sub-css';
              s.innerHTML = `
                .loop-widget-purchase-option-radio,
                .loop-widget-purchase-option-radio svg { cursor: pointer; pointer-events: auto; }
              `;
              document.head.appendChild(s);
            }
          } catch (e) { /* ignore */ }

          // Utility: get the event composed path (robust across Shadow DOM and SVG)
          const getEventPath = (ev) => {
            if (ev.composedPath) return ev.composedPath();
            if (ev.path) return ev.path;
            // fallback: walk up parentNode chain
            const arr = [];
            let node = ev.target;
            while (node) {
              arr.push(node);
              node = node.parentNode || (node.host || null);
            }
            return arr;
          };

          const findInPath = (path, predicate) => {
            if (!path || !path.length) return null;
            for (let i = 0; i < path.length; i++) {
              const node = path[i];
              if (!node) continue;
              try {
                if (predicate(node)) return node;
              } catch (err) { continue; }
            }
            return null;
          };

          // Click handler using composedPath to locate target ancestor (works for SVG)
          this.container.addEventListener('click', (ev) => {
            const path = getEventPath(ev);

            const oneTime = findInPath(path, n => n.getAttribute && n.hasAttribute('data-loop-widget-onetime-purchase-option'));
      
            if (oneTime) {
            const priceCompare = document.querySelector('.price-compare');
            const priceDashed = document.querySelector('.price-dashed');
            if (priceCompare) priceCompare.classList.add('hidden');
            if (priceDashed) priceDashed.classList.add('hidden');
              setTimeout(() => {
                if (this.variantPriceFromScript != null) {
                  this.mainProductPrice = Number(this.variantPriceFromScript);
                } else {
                  this.mainProductPrice = 0;
                }
                this.activeSellingPlan = false;
                this.activeSellingname = false;
                this.renderPrice();
                  
                this.updatePurchaseOptionLabel(null, { innerText: 'One-time purchase' }, this.container.querySelector('.loop-widget-container'));
              }, 120);
              return;
            }

            const subGroup = findInPath(path, n => n.getAttribute && n.hasAttribute('data-loop-widget-selling-plan-group'));
            if (subGroup) {
              setTimeout(() => this._handleApplySubscriptionFromGroup(subGroup), 120);
            }

          }, { passive: true });

          // Keyboard support: Enter / Space should trigger click on nearest option
          this.container.addEventListener('keydown', (ev) => {
            if (ev.key !== 'Enter' && ev.key !== ' ') return;
            const path = getEventPath(ev);
            const option = findInPath(path, n => n.getAttribute && (n.hasAttribute('data-loop-widget-onetime-purchase-option') || n.hasAttribute('data-loop-widget-selling-plan-group')));
            if (option) {
              // simulate click flow
              try { option.click(); } catch (e) {
                // fallback: dispatch event
                const ce = new MouseEvent('click', { bubbles: true, cancelable: true });
                option.dispatchEvent(ce);
              }
              ev.preventDefault();
            }
          }, { passive: false });

          // Quantity inputs (unchanged behavior) --------------------------------
          const qtySelector = 'input[name="quantity"]';
          const qtyInput = this.container.querySelector(qtySelector) || document.querySelector(qtySelector);
          if (qtyInput) {
            const qtyHandler = (ev) => {
              try {
                const val = parseInt(ev?.target?.value || qtyInput.value || '1', 10) || 1;
                this.renderPrice(val);
              
              } catch (err) {
                console.error('[xMainProductSubscription] qtyHandler error', err);
              }
            };
            qtyInput.addEventListener('input', qtyHandler, { passive: true });
            qtyInput.addEventListener('change', qtyHandler, { passive: true });

            try {
              const mo = new MutationObserver(() => {
                const val = parseInt(qtyInput.value || '1', 10) || 1;
                this.renderPrice(val);
            
              });
              mo.observe(qtyInput, { attributes: true, attributeFilter: ['value'] });
              this._qtyMutationObserver = mo;
            } catch (err) { /* ignore */ }
          }
        },

        _handleApplySubscriptionFromGroup(loopSubscription) {
          try {
            if (!loopSubscription) return;
            if (!loopSubscription.classList.contains('loop-widget-purchase-option-selected') && !loopSubscription.querySelector('.loop-widget-purchase-option-selected')) {
              return;
            }
            
            const select = loopSubscription.querySelector('[name="selling_plan"]');
            const selectedOption = select?.selectedOptions?.[0] || loopSubscription.querySelector('.loop-widget-purchase-option-selected [data-selling-plan-id]') || loopSubscription.querySelector('[data-selling-plan-id]');
            if (!selectedOption) return;

            const selectedLabelEl = loopSubscription.querySelector('.loop-widget-purchase-option-selected .loop-widget-purchase-option-label')
              || selectedOption?.parentElement?.querySelector('.loop-widget-purchase-option-label')
              || loopSubscription.querySelector('.loop-widget-purchase-option-label');

            const planName = selectedOption.innerText?.trim() || selectedOption.value;
            const sellingPlanObj = this.main_product?.main_product?.selling_plan?.[planName];

            if (!sellingPlanObj) return;

            this.mainProductPrice = Number(sellingPlanObj.price);
            this.activeSellingPlan = sellingPlanObj.id || selectedOption.value;
            this.activeSellingname = planName;

            this.renderPrice();
            
            const loopWidget = this.container.querySelector('.loop-widget-container');
            this.updatePurchaseOptionLabel(selectedLabelEl, selectedOption, loopWidget || loopSubscription);
            const priceCompare = document.querySelector('.price-compare');
            const priceDashed = document.querySelector('.price-dashed');
            if (priceCompare) priceCompare.classList.remove('hidden');
            if (priceDashed) priceDashed.classList.remove('hidden');
          } catch (e) {
            console.error('[xMainProductSubscription] _handleApplySubscriptionFromGroup error', e);
          }
        },

        _startLoopWatcher(el) {
          let loopTimer = setInterval(() => {
            const found = el.querySelector('.loop-widget-container [data-loop-widget-selling-plan-group]');
            if (found) {
              clearInterval(loopTimer);
              setTimeout(() => this._applySellingPlanAfterExternalChange(), 0);
            }
          }, 100);

          // setTimeout(() => {
          //   try { clearInterval(loopTimer); } catch(e){}
          //   const foundRetry = el.querySelector('.loop-widget-container [data-loop-widget-selling-plan-group]');
          //   if (foundRetry) {
          //     this._applySellingPlanAfterExternalChange();
          //   }
          // }, 3000);

          window.addEventListener('load', () => {
         
            setTimeout(() => {
         
              try { clearInterval(loopTimer); } catch(e){}
            }, 10000);
          });
        },

        _applySellingPlanAfterExternalChange() {
          try {
            const loopWidget = this.container.querySelector('.loop-widget-container');
            if (!loopWidget) return;

            const loopSubscription = loopWidget.querySelector('[data-loop-widget-selling-plan-group]');
            const loopOneTime = loopWidget.querySelector('[data-loop-widget-onetime-purchase-option]');

            if (loopSubscription && loopSubscription.classList.contains('loop-widget-purchase-option-selected')) {
              const select = loopSubscription.querySelector('[name="selling_plan"]');
              const selectedOption = select?.selectedOptions?.[0] || loopSubscription.querySelector('.loop-widget-purchase-option-selected [data-selling-plan-id]') || loopSubscription.querySelector('[data-selling-plan-id]');
              const planName = selectedOption ? (selectedOption.innerText?.trim() || selectedOption.value) : null;
              const sellingPlanObj = planName ? (this.main_product?.main_product?.selling_plan?.[planName]) : null;

              if (sellingPlanObj) {
                this.mainProductPrice = Number(sellingPlanObj.price);
                this.activeSellingPlan = sellingPlanObj.id || selectedOption?.value;
                this.activeSellingname = planName;
                this.renderPrice();
                const faqWrapper = document.querySelector('.product-faq-wrapper'); 
                const targetDivs = loopSubscription.querySelector('.loop-widget-sp-selector-description');

                function headerOffsetPx() {
                  const header =
                    document.querySelector('[data-header], header, .header, .site-header, .shopify-section-header');
                  if (!header) return 0;

                  const cs = getComputedStyle(header);
                  const isFixed = cs.position === "fixed" || cs.position === "sticky";
                  return isFixed ? Math.ceil(header.getBoundingClientRect().height) : 0;
                }

                function waitForEl(selector, timeout = 5000) {
                  return new Promise((resolve, reject) => {
                    const el = document.querySelector(selector);
                    if (el) return resolve(el);

                    const obs = new MutationObserver(() => {
                      const el = document.querySelector(selector);
                      if (el) {
                        obs.disconnect();
                        resolve(el);
                      }
                    });

                    obs.observe(document.documentElement, { childList: true, subtree: true });

                    setTimeout(() => {
                      obs.disconnect();
                      reject(new Error("Element not found: " + selector));
                    }, timeout);
                  });
                }

                async function scrollToSelector(selector, { extraOffset = 8, retries = 3 } = {}) {
                  const el = await waitForEl(selector);

                  // some Shopify sections open/animate after click; retry helps beat layout shifts
                  for (let i = 0; i < retries; i++) {
                    await new Promise(r => requestAnimationFrame(() => requestAnimationFrame(r)));

                    const top =
                      el.getBoundingClientRect().top + window.pageYOffset - headerOffsetPx() - extraOffset;

                    window.scrollTo({ top, behavior: "smooth" });

                    // if we’re close enough, stop retrying
                    await new Promise(r => setTimeout(r, 250));
                    const current = window.pageYOffset;
                    if (Math.abs(current - top) < 6) break;
                  }
                }


                let handleAnchor = () => {
                  let link = targetDivs.querySelector('a');
                  link.addEventListener('click',(event) => {
                    event.preventDefault();
                    if(link.classList.contains('active-link')){
                      return;
                    }
                    link.classList.add('active-link');
                    console.log("-->> ",faqWrapper)
                    if (faqWrapper) {
                      scrollToSelector('.product-faq-wrapper');
                    }else{
                      window.location.href = link.href;
                    }
                    setTimeout(() => {
                      let faqBtn = faqWrapper.querySelector('.faq-collapsible');
                      let faqDesc = faqBtn.nextElementSibling.hasAttribute('hidden');
                      if (faqDesc) {
                        faqBtn.click();
                      }
                    },1500);
                  });
                };

                handleAnchor();
                const observer = new MutationObserver(mutations => {
                  mutations.forEach(mutation => {
                    mutation.addedNodes.forEach(node => {
                      if (node.nodeType === 1) handleAnchor(node);
                    });
                  });
                });
                observer.observe(targetDivs, { childList: true, subtree: true });
                
                const selectedLabelEl = loopSubscription.querySelector('.loop-widget-purchase-option-selected .loop-widget-purchase-option-label')
                  || loopSubscription.querySelector('.loop-widget-purchase-option-label');
                this.updatePurchaseOptionLabel(selectedLabelEl, selectedOption, loopWidget);
                return;
              }
            }

            if (loopOneTime && loopOneTime.classList.contains('loop-widget-purchase-option-selected')) {
              if (this.variantPriceFromScript != null) {
                this.mainProductPrice = Number(this.variantPriceFromScript);
              } else {
                this.mainProductPrice = 0;
              }
              this.activeSellingPlan = false;
              this.activeSellingname = false;
              this.renderPrice();
              this.updatePurchaseOptionLabel(null, { innerText: 'One-time purchase' }, loopWidget);
            }
          } catch (e) {
            console.error('[xMainProductSubscription] _applySellingPlanAfterExternalChange error', e);
          }
        },



        renderPrice(qty = null) {
          try {
            if (!this.container) return;
            const qtys = qty !== null
              ? Math.max(1, parseInt(qty, 10))
              : Math.max(1, parseInt((this.container.querySelector('input[name="quantity"]') || document.querySelector('input[name="quantity"]'))?.value || '1', 10));
            const base = Number(this.mainProductPrice) || 0;
            const priceCents = Math.round(base * qtys);
            const unitPriceCents = Math.round(base);

            let formatted;
            try {
              formatted = this.formatMoney(priceCents, shopCurrency);
            } catch (fmtErr) {
              formatted = null;
            }

            if (typeof formatted !== 'string' || formatted.trim() === '') {
              const fallback = (priceCents / 100).toFixed(2);
              if (typeof shopCurrency === 'string' && /\{\{\s*\w+\s*\}\}/.test(shopCurrency)) {
                formatted = String(shopCurrency).replace(/\{\{\s*\w+\s*\}\}/, fallback);
              } else {
                formatted = fallback;
              }
            }
            let pformatted;
            try {
              pformatted = this.formatMoney(unitPriceCents, shopCurrency);
            } catch (fmtErr) {
              pformatted = null;
            }

            if (typeof pformatted !== 'string' || pformatted.trim() === '') {
              const fallback = (unitPriceCents / 100).toFixed(2);
              if (typeof shopCurrency === 'string' && /\{\{\s*\w+\s*\}\}/.test(shopCurrency)) {
                pformatted = String(shopCurrency).replace(/\{\{\s*\w+\s*\}\}/, fallback);
              } else {
                pformatted = fallback;
              }
            }

            // update xblocks price element if present
            const xblocksPriceEl = this.container.querySelector('.x-block-price');
            const loopSubscriptionType =this.container.querySelector('.loop-widget-container');
            const loopTyepeCheck = loopSubscriptionType.querySelector('[data-loop-widget-onetime-purchase-option]');
            const parentTopSubscriptionPrice = document.querySelector('.bundle-subscribition-price');
            if(parentTopSubscriptionPrice){
            const priceCompare = parentTopSubscriptionPrice.querySelector('.price-compare');
            const priceDashed = parentTopSubscriptionPrice.querySelector('.price-dashed')
            if (loopTyepeCheck && loopTyepeCheck.classList.contains('loop-widget-purchase-option-selected')) {
                 priceCompare?.classList.add('hidden');
                 priceDashed?.classList.add('hidden');
           }else{
                priceCompare?.classList.remove('hidden');
                priceDashed?.classList.remove('hidden');
           }
            }
            if (xblocksPriceEl) {
              const visibleEl = xblocksPriceEl.querySelector('.js-product-price');
              const hiddenEl  = xblocksPriceEl.querySelector('.target-price');
              if (visibleEl && hiddenEl) {
                visibleEl.innerHTML = pformatted;           // formatted price
                hiddenEl.innerHTML  = String(unitPriceCents); // raw cents
                hiddenEl.setAttribute('data-price-cents', unitPriceCents);
              }
            }
            const oneTimeprice = document.querySelector("[id^='loop-widget-purchase-option-price-onetime-']");
            const parentspriceClass = document.querySelectorAll('.product-info');
            parentspriceClass.forEach(parent => {
              const priceCompare = parent.querySelector('.price-compare');
              if (priceCompare && oneTimeprice) {
                 priceCompare.textContent = oneTimeprice.textContent.trim();
              }
            });

            const bundlePriceBox = document.querySelector('.bundle-subscribition-price');
            // console.log("bundlePriceBox_bundlePriceBox", bundlePriceBox);

            if (bundlePriceBox && oneTimeprice) {
                let smallTag = bundlePriceBox.querySelector('small.cap');
                let spanDashed = bundlePriceBox.querySelector('.price-dashed');

                // If elements don't exist, create them
                if (!smallTag) {
                    smallTag = document.createElement('small');
                    smallTag.className = 'cap rtl:inline-block';
                    
                    const sTag = document.createElement('s');
                    sTag.className = 'price-compare rtl:leading-tight';
                    smallTag.appendChild(sTag);
                    
                    // Prepend smallTag (it will be the first child)
                    bundlePriceBox.prepend(smallTag);
                }

                if (!spanDashed) {
                    spanDashed = document.createElement('span');
                    spanDashed.className = 'price-dashed';
                    spanDashed.innerText = '- ';
                    
                    // Insert spanDashed after smallTag
                    smallTag.after(spanDashed);
                }

                // Update content
                const sTag = smallTag.querySelector('s.price-compare');
                if (sTag) {
                    sTag.textContent = oneTimeprice.textContent.trim();
                }
            }


        
            // update other selectors (buttons / add-to-cart)
            const selectors = [
              '.js-add_to_cart_btn .js-product-price'
            ].join(', ');

            let els = [];
            try {
              els = Array.from(this.container.querySelectorAll(selectors));
            } catch (err) {
              els = [];
            }
            if (!els.length) {
              els = Array.from(document.querySelectorAll(selectors));
            }

            els.forEach(el => {
              el.innerHTML = formatted;
              try { if (el.setAttribute) el.setAttribute('data-price-cents', String(priceCents)); } catch (err) {}
            });

          } catch (e) {
            console.error('[xMainProductSubscription] renderPrice error', e);
          }
        },

        formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
          if (number == null || isNaN(number)) return '0';
          const fixed = (number / 100.0).toFixed(precision);
          const parts = fixed.split('.');
          const dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
          const cents = parts[1] ? (decimal + parts[1]) : '';
          return dollars + cents;
        },

        formatMoney(amount, formatString) {
          try {
            const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
            const match = String(formatString || '{{ amount }}').match(placeholderRegex);
            if (!match) return (amount / 100).toFixed(2);
            const key = match[1];
            let value;
            switch (key) {
              case 'amount': value = this.formatWithDelimiters(amount, 2); break;
              case 'amount_no_decimals': value = this.formatWithDelimiters(amount, 0); break;
              case 'amount_with_comma_separator': value = this.formatWithDelimiters(amount, 2, '.', ','); break;
              case 'amount_no_decimals_with_comma_separator': value = this.formatWithDelimiters(amount, 0, '.', ','); break;
              default: value = (amount / 100).toFixed(2);
            }
            return String(formatString).replace(placeholderRegex, value);
          } catch (e) {
            return (amount / 100).toFixed(2);
          }
        },

        updatePurchaseOptionLabel(selectedLabelEl, selectedOption, loopWidget) {
          try {
            if (!loopWidget) loopWidget = this.container.querySelector('.loop-widget-container');
            let wrapper = loopWidget.querySelector('.loop-widget-purchase-options-label');

            if (wrapper && !wrapper.querySelector('.purchase-option-label')) {
              const originalText = wrapper.textContent.trim();
              wrapper.innerHTML = '';
              const purchaseLabel = document.createElement('span');
              purchaseLabel.className = 'purchase-option-label';
              purchaseLabel.innerText = originalText ? (originalText + ' : ') : 'Purchase Options : ';
              wrapper.appendChild(purchaseLabel);
              const planNameLabel = document.createElement('span');
              planNameLabel.className = 'selected-plan-name-label';
              wrapper.appendChild(planNameLabel);
            }

            if (!wrapper) {
              wrapper = document.createElement('div');
              wrapper.className = 'loop-widget-purchase-options-label';
              const purchaseLabel = document.createElement('span');
              purchaseLabel.className = 'purchase-option-label';
              purchaseLabel.innerText = 'Purchase Options : ';
              wrapper.appendChild(purchaseLabel);
              const planNameLabel = document.createElement('span');
              planNameLabel.className = 'selected-plan-name-label';
              planNameLabel.innerText = '';
              wrapper.appendChild(planNameLabel);
              (loopWidget.querySelector('[data-loop-widget-selling-plan-group]') || loopWidget).appendChild(wrapper);
            }

            const planLabel = wrapper.querySelector('.selected-plan-name-label');
            const planText = (selectedLabelEl && selectedLabelEl.innerText)
              ? selectedLabelEl.innerText.trim()
              : (selectedOption?.innerText?.trim() || '');

            if (planLabel) planLabel.innerText = planText;
          } catch (e) {
            console.error('[xMainProductSubscription] updatePurchaseOptionLabel error', e);
          }
        },

      }));
    });
  });
}
